<template>
	<Transition name="appear">
		<div v-if="station.info != null" class="absolute shrink-0 h-full w-full md:w-[400px] overflow-hidden z-20 bg-background">
			<div class="infoContent relative">

				<button class="absolute right-0 mr-4 w-8 h-8 flex items-center" style="border-radius: 100%;" @click="closeOnClick">
					<FontAwesomeIcon :icon="faXmark" />
				</button>

				<div
					style="display: flex; flex-direction: row; justify-content: space-between; align-items: flex-start;"
				>
					<h2 style="display: flex; align-items: center;">
						<FontAwesomeIcon style="margin-right: 0.35em;" :icon="getStationIcon(station.info)" />
						<span>{{ station.info.name }}</span>
					</h2>
					
				</div>

				<div class="descriptionContainer">
					<div>
						<FontAwesomeIcon :icon="faLocationCrosshairs"/>
						{{ station.info.address }}
					</div>
					<div>
						<FontAwesomeIcon :icon="faClock"/>
						{{ stationLastOnline }}
					</div>
				</div>

				<br />

				<div class="flex flex-row gap-2 mb-4">
					<button class="btn" @click="isShareModalOpen = true">
						Поширити
						<FontAwesomeIcon :icon="faShare" />
					</button>
					<button class="btn" @click="subscribeOnClick()">
						Підписатись
						<FontAwesomeIcon :icon="faBell" />
					</button>
				</div>

				<div>
					<ModalComponent :isOpen="isShareModalOpen" @modal-close="isShareModalOpen = false">
						<template #header>
							Поширити станцію
						</template>
						<template #content>
							<div>
								<!-- <div style="margin-bottom: 0.5em;"></div> -->
								<span>
									✨ Тримай це зображення! Воно буде просто прекрасно виглядати на твоєму сайті чи в соцмережі.
								</span>
							</div>
							<br>
							
							<StationShare :stationData="station.data" />
							<!-- <br/>
							<p>Поширити посилання на станцію</p>
							<ShareThis /> -->
							<br/> 
						</template>
					</ModalComponent>
				</div>

				<div v-show="showData">
					<PanelNote 
						v-if="station.info.service == true"
						class="mb-4"
					>
						<template #icon>
							<FontAwesomeIcon :icon="faTriangleExclamation"/>
						</template>
						<template #title>
							Дані можуть бути не точними
						</template>
						<template #description>
							Ця станція потребує обслуговування. 
							Дані можуть не відповідати реальним. <br/>
							<a href="https://eco-city.org.ua/article?id=18" target="_blank">
								Це моя станція, що робити?
							</a>
						</template>
					</PanelNote>
					<PanelNote 
						v-else-if="station.info.type == 'indoor'"
						class="mb-4"
					>
						<template #icon>
							<FontAwesomeIcon :icon="faTriangleExclamation"/>
						</template>
						<template #title>
							Дані можуть бути не точними
						</template>
						<template #description>
							Ця станція встановлена всередині приміщення.
							Дані можуть не відповідати значенням на вулиці. 
						</template>
					</PanelNote>

					<h3>Діаграма UAQI</h3>
					<small class="text-muted-foreground">
						Діаграма показує забруднення по окремих категоріях забрудників.
						<a class="text-foreground" href="https://eco-city.org.ua/article?id=5" target="_blank">Що означає цей рівень?</a>
					</small>
					<br /><br />
					<div>
						<UaqiDiagram :uaqi=uaqi />
					</div>
					<br />

					<h3>Забрудники</h3>
					<small class="text-muted-foreground">
						Тут представлений список всіх показників, що виміряються цією станцією.
						<a class="text-foreground" href="https://eco-city.org.ua/article?id=5" target="_blank">Що означають ці кольори?</a>
					</small>
					<br /><br />
					<div>
						<StationValue v-for="v in station.data?.current_values" :key="v" :value="v" class="mb-2 animate-[pulse_0.5s_1]"/>
					</div>
				</div>
				<div v-show="!showData">
					<PanelNote>
						<template #icon>
							<FontAwesomeIcon :icon="faTriangleExclamation"/>
						</template>
						<template #title>
							Дані застарілі
						</template>
						<template #description>
							Востаннє ця станція надсилала дані більш ніж годину тому. 
							<a 
								@click="showOldData = true"
								style="text-decoration: underline; cursor: pointer;"
							>
								Показати?
							</a>
						</template>
					</PanelNote>
				</div>
				<br />

				<h3>Треба більше даних?</h3>
				<br />
				
				<StatsButton @click="statsOnClick" />

				<br />
				<h3>Джерело даних</h3>
				<br />
				<PanelBox 
					v-if="station.data?.owner != null && station.data?.owner?.logo && station.data.owner.logo.length > 0"
					class="flex flex-row items-center gap-3 mb-2"
				>
					<div class="w-16 h-16 aspect-square rounded overflow-hidden shrink-0 bg-neutral-100 dark:bg-neutral-900">
						<img 
							:src="'https://reborn.eco-city.org.ua/logos/' + station.data.owner.logo" 
							alt="user logo" 
							class="w-full h-full object-cover"
						>
					</div>
					<div>
						<div>
							<h4 class="my-0">
								<span v-if="station.data?.owner?.url == '' || station.data?.owner?.url == null">
									{{ station.data?.owner?.name }}
								</span>
								<a v-else :href="station.data?.owner?.url" target="_blank" rel="noopener noreferrer">
									{{ station.data?.owner?.name }}
								</a>
							</h4>
							<small>Власник станції</small>
						</div>
					</div>
				</PanelBox>

				<PanelBox class="flex flex-row items-center gap-2">
					<div class="w-10 h-10 p-1 aspect-square rounded shrink-0 bg-neutral-100 dark:bg-neutral-900">
						<img class="w-full h-full not-dark:invert" v-if="station.data?.provider == 'ecocity'" src="@/assets/providers/ecocity.svg" alt="data provider logo">
						<img class="w-full h-full not-dark:invert" v-else-if="station.data?.provider == 'emc'" src="@/assets/providers/emc.svg" alt="data provider logo">
						<img class="w-full h-full not-dark:invert" v-else-if="station.data?.provider == 'lun'" src="@/assets/providers/lun.svg" alt="data provider logo">
					</div>
					<div>
						<div v-if="station.data?.provider == 'ecocity'">
							{{ providerToText[station.data?.provider] }}
						</div>
						<div v-else>
							<a :href="providerToUrl[station.data?.provider]">
								{{ providerToText[station.data?.provider] }}
							</a>
						</div>
					</div>
				</PanelBox>

				<br /><br />
			</div>
		</div>
	</Transition>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
	faTriangleExclamation, 
	faXmark, 
	faBell, 
	faShare,
	faLocationCrosshairs 
} from '@fortawesome/free-solid-svg-icons'

import { faClock } from '@fortawesome/free-regular-svg-icons'

import PanelBox from '@/components/ui/PanelBox.vue'
import PanelNote from '@/components/ui/PanelNote.vue'

import StationValue from '@/components/StationValue.vue'
import UaqiDiagram from './UaqiDiagram.vue'
import ModalComponent from './ui/ModalComponent.vue'
// import ShareThis from './ShareThis.vue'
import StationShare from './StationShare.vue'
import StatsButton from './StatsButton.vue'

import { SelectedStation } from '@/state/SelectedStation.js'
import { getStationIcon } from '@/modules/StationIcon.js'

import { differenceInMinutes } from 'date-fns';

const router = useRouter()

const providerToText = {
	"ecocity": "Мережа EcoCity",
	"emc": "Центр Екологічного Моніторингу",
	"lun": "Lun Місто Air"
}

const providerToUrl = {
	"ecocity": "https://reborn.eco-city.org.ua",
	"emc": "https://ecomonitoring.info/",
	"lun": "https://lun.ua/misto/air"
}

const isShareModalOpen = ref(false)

function statsOnClick() 
{
	router.push(
		{ 
			name: 'station', 
			params: { id: station.value.info.id } 
		}
	)
}

function closeOnClick() { 
	SelectedStation.remove()
}

function subscribeOnClick() {
	window.alert('Ця функція поки не реалізована(')
}

const stationLastOnline = computed(()  => {
	if (station.value.data == null || station.value.data.id != station.value.info.id) {
		return station.value.info.last_online
	} else {
		return station.value.data.last_online
	}
})

const dataIsTooOld = computed(() => {
	return differenceInMinutes(new Date(), new Date(stationLastOnline.value)) > 60
})

const showOldData = ref(false)

const showData = computed(() => { return dataIsTooOld.value == false || showOldData.value == true })

SelectedStation.onStationChanged(function () {
	showOldData.value = false
})

const station = computed(() => {
	return {
		info: SelectedStation.getInfo(),
		data: SelectedStation.getData()
	}
})

const uaqi = computed(() => {
	const uaqi = station.value?.data?.uaqi

	if (uaqi == null) return { 
		main: 0,
		pm: 0,
		mainGases: 0,
		otherGases: 0,
		radiation: 0
	};

	return {
		main: uaqi.main,
		pm: uaqi.categories.A,
		mainGases: uaqi.categories.B,
		otherGases: uaqi.categories.C,
		radiation: uaqi.categories.D
	}
})

let updateDataInterval = null

onMounted(() => {
	updateDataInterval = setInterval(() => {
		if (SelectedStation.station != null) {
			SelectedStation.fetchData()
			SelectedStation.fetchGraph()
		}
	}, 5000)
})

onBeforeUnmount(() => {
	clearInterval(updateDataInterval.value) 
})
</script>

<style scoped>
.descriptionContainer svg {
	width: 1em;
}

.descriptionContainer > div {
	white-space: nowrap;
	overflow: hidden;
    text-overflow: ellipsis;
}

h3 {
	margin-top: 0.5em;
	margin-bottom: 0.1em;
}

.infoContent {
	box-sizing: border-box;
	width: 100%;
	height: 100%; 

	/* For proper animations */
	min-width: 400px;

	overflow-y: scroll;
	overflow-x: hidden;

	padding: 20px;
}

@media only screen and (max-width: 700px) {
	.infoContent {
		min-width: 100vw;
	}
}

.appear-enter-active,
.appear-leave-active {
	transition: max-width 1s ease;
	max-width: 100%;
}

.appear-enter-from,
.appear-leave-to {
	max-width: 0em;
}
</style>